import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { SearchService } from "../../services/search-service";
import { AclService } from "../../services/acl-service";
import { DataSecurityService } from "../../services/data-security-service";
import { EntityConfigService } from "../../services/entity-config-service";

export class RelativeRightsProfilesController {
	public static $inject = [
		"$scope",
		"$q",
		"$window",
		"entityService",
		"entityConfigService",
		"notifyService",
		"searchService",
		"aclService",
		"dataSecurityService"
	];

	showJobProgressStatus: boolean = false;
	jobId: string = "";
	jobTitle: string = "";
	jobTemplateID: number;
	jobCharTypeID: number;
	progressStatus: string;

	//Rights Profiles
	openProfileModal: boolean = false;
	rightsInitialized: boolean = false;
	isEditing: boolean;
	isCreating: boolean;

	isRightEditing: boolean;
	isRightCreating: boolean;
	editRightEntityID: string;
	visibility: 2;

	divID: number = 0;
	charTypeID: number;
	rightCharTypeID: number;
	rightTemplateID: number;
	profileEntityID: string;
	rightEntityCharDataCollection: Models.ICharDataCollection;
	wizardStep: number = 1;

	profiles: Models.IEntitySearchDoc[] = [];
	profile: Models.IRelativeRightsProfile;

	rightGroupCMDs: { [templateID: string]: Models.ICharacteristicMetaData[] } = {};
	rightGroupCharDatas: {
		[templateID: string]: { [recordID: string]: { [charID: string]: Models.ICharDataValueFullName[] } }
	} = {};
	rightEntityCurrencyCharDatas: { [entityID: string]: Models.ICharDataValue };

	rightNumFound: { [templateID: number]: number } = {};
	rightPageCount: { [templateID: number]: number } = {};
	rightRowCount: { [templateID: number]: number } = {};
	rightPage: { [templateID: number]: number } = {};

	//Tables
	openTableModal: boolean = false;
	tablesInitialized: boolean = false;

	isTableEditing: boolean;
	isTableCreating: boolean;
	editTableEntityID: string;

	tableCharTypeID: number;
	tableTemplateID: number;
	tableMockEntityID: string;
	tableEntityCharDataCollection: Models.ICharDataCollection;
	selectedTables: string[] = [];

	tables: Models.IMockRelatedEntityResponse;
	groupCMDs: { [templateID: string]: Models.ICharacteristicMetaData[] } = {};
	groupCharDatas: {
		[templateID: string]: { [recordID: string]: { [charID: string]: Models.ICharDataValueFullName[] } }
	} = {};
	entityCurrencyCharDatas: { [entityID: string]: Models.ICharDataValue } = {};

	numFound: { [templateID: number]: number } = {};
	pageCount: { [templateID: number]: number } = {};
	rowCount: { [templateID: number]: number } = {};
	page: { [templateID: number]: number } = {};

	public constructor(private readonly $scope: ng.IScope,
		private readonly $q: ng.IQService,
		private readonly $window: ng.IWindowService,
		private readonly entityService: EntityService,
		private readonly entityConfigService: EntityConfigService,
		private readonly notifyService: NotifyService,
		private readonly searchService: SearchService,
		private readonly aclService: AclService,
		private readonly dataSecurityService: DataSecurityService) {

		$scope.$watch(() => this.rightTemplateID, (newValue, oldValue) => {
			this.GetRightsCharData();
		});

		$scope.$watch(() => this.tableTemplateID, (newValue, oldValue) => {
			this.GetTableCharData();
		});

		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && newValue == "Done") {
				this.showJobProgressStatus = false;

				if (this.jobCharTypeID == Consts.CharTypeIDs.usage) {
					this.GetTables(1, this.rowCount[this.jobTemplateID], this.jobTemplateID);
				}

				if (this.jobCharTypeID == Consts.CharTypeIDs.right) {
					this.GetRights(1, this.rowCount[this.jobTemplateID], this.jobTemplateID);
				}

				this.jobCharTypeID = undefined;
				this.jobTemplateID = undefined;
				this.jobTitle = undefined;
			}
		});
	}

	Init(rightTemplateID: number, tableTemplateID: number, tableMockEntityID: string) {
		this.charTypeID = Consts.CharTypeIDs.mock;
		this.rightCharTypeID = Consts.CharTypeIDs.right;
		this.rightTemplateID = rightTemplateID;

		this.tableMockEntityID = tableMockEntityID;
		this.tableCharTypeID = Consts.CharTypeIDs.usage;
		this.tableTemplateID = tableTemplateID;

		this.profile = {
			name: "", entityID: "", rights: null
		};

		this.GetProfiles();
	}

	GetRightsCharData() {
		this.notifyService.startProgress();
		var template = Utils.IdBuilder.buildTemplateID(this.divID, this.rightCharTypeID, this.rightTemplateID);
		return this.entityService.getEmptyEntityCharData(template)
			.then((result) => {
				this.rightEntityCharDataCollection = result;
				this.divID = result.templateMetaData.divID;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	CreateProfile() {
		this.profile = {
			name: "", entityID: "", rights: null
		};
		this.wizardStep = 1;
		this.openProfileModal = true;
		this.isEditing = false;
		this.isCreating = true;
		this.isRightEditing = false;
		this.isRightCreating = true;
	}

	EditProfile(mock: Models.IEntitySearchDoc) {
		this.isEditing = true;
		this.isCreating = false;
		this.profileEntityID = mock.entityID;
		this.wizardStep = 3;
		this.openProfileModal = true;

		this.profile = {
			name: mock.title,
			entityID: mock.entityID,
			rights: null
		}

		//Get the Profile rights
		this.GetRights();
	}

	DeleteProfile(mock: Models.IEntitySearchDoc) {
		if (this.$window.confirm("Are you sure?")) {
			this.entityService.deleteEntity(mock.entityID)
				.then((result) => {
					this.showJob(result.jobID, result.jobTitle, mock.templateID, Consts.CharTypeIDs.mock);
					this.notifyService.notifySuccess("Relative Rights Profile deleted.");
					this.profiles = this.profiles.filter(x => x.recordID !== mock.recordID);
				});
		}
	}

	GetProfiles() {
		this.notifyService.startProgress();
		this.tablesInitialized = false;
		var request: Models.IAdvancedSearchModel = {
			charTypeID: Consts.CharTypeIDs.mock,
			searchGroups: [],
			keywords: "",
			page: 1,
			rowCount: 100
		};

		this.searchService.advancedSearch(request)
			.then((results) => {
				this.profiles = _.sortBy(_.filter(results.documents, d => d.templateID == 1), p => p.title);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	SaveProfile(isDirty: boolean): ng.IPromise<any> {
		//Save or Edit the profile Mock

		//For now, we'll default to the ONLY template we have for the Mock chartype ID 1
		this.notifyService.startProgress();
		var template = Utils.IdBuilder.buildTemplateID(this.divID, Consts.CharTypeIDs.mock, 1);
		return this.entityService.getEmptyEntityCharData(template)
			.then((result) => {
				var profileChars = result;

				var titleCharID = _.first(_.filter(result.templateMetaData.characteristicMetaDatas, f => f.tagLabel == "entity_title"));

				if (this.isCreating) {
					profileChars.charDatas["entity_title"] = [{ charID: titleCharID.characteristicID, recCharID: 0, value: this.profile.name, valueID: null }];

					return this.entityService.createEntity(template, null, profileChars.charDatas)
						.then((result) => {
							this.profileEntityID = result.entityID;
							this.profile.entityID = result.entityID;
						})
						.finally(() => {
							this.notifyService.endProgress();
							this.isCreating = false;
							this.isEditing = true;
							this.wizardStep = 2;
						});
				}
				else if (this.isEditing && isDirty) {
					return this.entityService.getEntityCharData(this.profile.entityID)
						.then((results) => {
							var currentProfileChars = result;

							if (currentProfileChars.charDatas["entity_title"].length > 0) {
								if (currentProfileChars.charDatas["entity_title"][0].value == this.profile.name) {
									//The form says isDirty, but it's not really
									//Don't do anything
									return;
								}
								else {
									currentProfileChars.charDatas["entity_title"][0].value = this.profile.name;
								}
							}
							else {
								currentProfileChars.charDatas["entity_title"] = [{ charID: titleCharID.characteristicID, recCharID: 0, value: this.profile.name, valueID: null }];
							}

							return this.entityService.saveCharData(this.profile.entityID, currentProfileChars.charDatas)
								.finally(() => {
									this.notifyService.endProgress();
									this.wizardStep = 3;
								});
						});

				}
				else {
					//Nuttin' has changed... move on
					this.notifyService.endProgress();
					this.wizardStep = 3;
				}
			})
	}

	GetRights(page: number = 1, rowCount: number = 10, templateID?: number) {
		this.notifyService.startProgress();

		if (!templateID) {
			this.rightsInitialized = false;
			this.rightGroupCMDs = {};
			this.rightGroupCharDatas = {};
			this.rightNumFound = [];
			this.rightPageCount = [];
			this.rightRowCount = [];
			this.rightPage = [];
			this.profile.rights = null;
		}

		//Get the templates
		var profileMockEntityRecordID = Utils.IdBuilder.splitEntityID(this.profile.entityID).recID;
		var start = (page - 1) * rowCount;

		this.entityConfigService.getMockRightsByTemplate(profileMockEntityRecordID, start, rowCount)
			.then((results) => {
				if (!templateID) {
					this.profile.rights = results.data;
				}

				if (templateID) {
					//Only update the template that was triggered
					var templateGroup = _.first(_.filter(this.profile.rights.groups, t => t.templateID == templateID));
					var resultGroup = _.first(_.filter(results.data.groups, t => t.templateID == templateID));
					if (resultGroup) {
						this.rightNumFound[templateID] = resultGroup.numFound;
						templateGroup.items = resultGroup.items;
						this.rightPageCount[templateID] = Math.ceil(resultGroup.numFound / rowCount);

						this.rightGroupCharDatas[templateID] = {};
						_.forEach(resultGroup.items,
							(item) => {
								this.rightGroupCharDatas[templateID][item.record.recordID] = _.groupBy(item.charData, (cd) => cd.charactersticID);

								//Pad out the collection with empty arrays for empty fields
								this.rightGroupCMDs[templateID].forEach(c => {
									if (this.rightGroupCharDatas[templateID][item.record.recordID][c.characteristicID] == null) {
										this.rightGroupCharDatas[templateID][item.record.recordID][c.characteristicID] = [];
									}
								})
							});
					}
					else {
						delete this.rightPage[templateID];
						delete this.rightRowCount[templateID];
						delete this.rightNumFound[templateID];

						var index = this.profile.rights.groups.indexOf(_.first(this.profile.rights.groups.filter(g => g.templateID == templateID)));
						this.profile.rights.groups.splice(index, 1);

						delete this.rightGroupCMDs[templateID];
						delete this.rightGroupCharDatas[templateID];
					}
				}
				else {
					//Process all the rights
					for (var i = 0; i < this.profile.rights.groups.length; i++) {
						var g = this.profile.rights.groups[i];
						this.rightPage[g.templateID] = page;
						this.rightRowCount[g.templateID] = rowCount;
						this.rightNumFound[g.templateID] = g.numFound;
						this.rightPageCount[g.templateID] = Math.ceil(g.numFound / rowCount);

						var cmds = this.dataSecurityService.filterVisibleGroupsCharacteristics(this.aclService.acls, g.templateMetaData, this.rightEntityCharDataCollection.charDatas, true);
						var visibleSorted: Models.ICharacteristicMetaData[] = [];

						var sortedGroups = _.sortBy(g.templateMetaData.groups, gr => gr.sequenceNumber);
						sortedGroups.forEach((group) => {
							var groupCmds2 = cmds.filter(cmd => cmd.groupID == group.groupID);
							if (_.any(groupCmds2)) {
								visibleSorted = visibleSorted.concat(groupCmds2);
							}
						});

						this.rightGroupCMDs[g.templateID] = visibleSorted;
						this.rightGroupCharDatas[g.templateID] = {};
						_.forEach(this.profile.rights.groups[i].items,
							(item) => {
								this.rightGroupCharDatas[g.templateID][item.record.recordID] = _.groupBy(item.charData, (cd) => cd.charactersticID);

								//Pad out the collection with empty arrays for empty fields
								cmds.forEach(c => {
									if (this.rightGroupCharDatas[g.templateID][item.record.recordID][c.characteristicID] == null) {
										this.rightGroupCharDatas[g.templateID][item.record.recordID][c.characteristicID] = [];
									}
								})
							});

						if (templateID && g.templateID == templateID) {
							return;
						}
					}
				}

				this.rightsInitialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	AddRight() {
		//Add another Right
		this.isRightEditing = false;
		this.isRightCreating = true;
		this.editRightEntityID = "";

		this.GetRightsCharData()
			.then(() => {
				this.wizardStep = 2;
			})
	}

	SaveRight() {
		//Save the right to the Mock
		this.notifyService.startProgress();
		if (this.isRightCreating) {
			var template = Utils.IdBuilder.buildTemplateID(this.divID, this.rightCharTypeID, this.rightTemplateID);
			this.entityService.createEntity(template, this.profileEntityID, this.rightEntityCharDataCollection.charDatas)
				.then((result) => {
					this.GetRights();
				})
				.finally(() => {
					this.wizardStep = 3;
					this.GetRightsCharData();
					this.notifyService.endProgress();
				});
		}
		else if (this.isRightEditing) {
			this.entityService.saveCharData(this.editRightEntityID, this.rightEntityCharDataCollection.charDatas)
				.then(() => {
					this.GetRights();
				})
				.finally(() => {
					this.wizardStep = 3;
					this.GetRightsCharData();
					this.notifyService.endProgress();
				});
		}
	}

	EditRight(right: Models.IEntity) {
		this.isRightEditing = true;
		this.isRightCreating = false;
		this.editRightEntityID = right.id;
		this.entityService.getEntityCharData(right.id)
			.then((results) => {
				this.rightEntityCharDataCollection = results;
				this.wizardStep = 2;
			});

	}

	DeleteRight(right: Models.IEntity) {
		if (this.$window.confirm("Are you sure?")) {
			this.entityService.deleteEntity(right.id)
				.then((result) => {
					//Update this template
					this.showJob(result.jobID, result.jobTitle, right.templateID, Consts.CharTypeIDs.right);
				});
		}
	}

	RightPageSizeChanged(pageSize: number, templateID: number) {
		this.rightRowCount[templateID] = pageSize;
		this.GetRights(1, pageSize, templateID);
	}

	RightPageChanged(page: number, templateID: number) {
		this.rightPage[templateID] = page;
		this.GetRights(page, this.rightRowCount[templateID], templateID);
	}

	GoBack(form: ng.IFormController) {
		//Reset the form
		form.$dirty = false;
		this.wizardStep = this.wizardStep - 1;
	}

	Close(isDirty: boolean, apply: boolean = false) {
		//If we're editing, check to see if the Profile needs to be updated/saved
		if (isDirty) {
			this.SaveProfile(isDirty)
				.then(() => {
					this.Reset();
				})
		}
		else {
			this.Reset();
		}

		if (apply) {
			this.ApplyProfile();
		}

		this.isRightEditing = false;
		this.isRightCreating = false;
		this.editRightEntityID = "";
	}

	ApplyProfile() {
		//We're passing in 3 for the Action ID which will do a delete and re-add
		this.entityService.applyRelativeRightsProfile(Utils.IdBuilder.splitEntityID(this.profileEntityID).recID, 3, null)
			.then((result) => {
				alert("The Relative Rights Profile is being applied to all existing Rights created by this Profile. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can leave this page and continue working elsewhere.");
			}, this.notifyService.errorResponseHandler);
	}

	Reset() {
		this.GetProfiles();
		this.isEditing = false;
		this.isCreating = false;
	}

	Cancel() {
		this.Close(false);
	}

	//Table Trigger Models
	GetTables(page: number = 1, rowCount: number = 10, templateID?: number) {

		this.notifyService.startProgress();

		if (!templateID) {
			this.tables = null;
			this.tablesInitialized = false;
		}

		//Get the templates
		var tableMockEntityRecordID = Utils.IdBuilder.splitEntityID(this.tableMockEntityID).recID;
		var start = (page - 1) * rowCount;

		this.entityConfigService.getMockTableTriggerModelsByTemplate(tableMockEntityRecordID, start, rowCount)
			.then((results) => {
				if (!templateID) {
					this.tables = results.data;
				}

				if (templateID) {
					//Only update the template that was triggered
					var templateGroup = _.first(_.filter(this.tables.groups, t => t.templateID == templateID));
					var resultGroup = _.first(_.filter(results.data.groups, t => t.templateID == templateID));
					if (resultGroup) {
						this.numFound[templateID] = resultGroup.numFound;
						templateGroup.items = resultGroup.items;
						this.pageCount[templateID] = Math.ceil(resultGroup.numFound / rowCount);

						this.groupCharDatas[templateID] = {};
						_.forEach(resultGroup.items,
							(item) => {
								this.groupCharDatas[templateID][item.record.recordID] = _.groupBy(item.charData, (cd) => cd.charactersticID);

								//Pad out the collection with empty arrays for empty fields
								this.groupCMDs[templateID].forEach(c => {
									if (this.groupCharDatas[templateID][item.record.recordID][c.characteristicID] == null) {
										this.groupCharDatas[templateID][item.record.recordID][c.characteristicID] = [];
									}
								})
							});
					}
					else {
						delete this.page[templateID];
						delete this.rowCount[templateID];
						delete this.numFound[templateID];

						var index = this.tables.groups.indexOf(_.first(this.tables.groups.filter(g => g.templateID == templateID)));
						this.tables.groups.splice(index, 1);

						delete this.groupCMDs[templateID];
						delete this.groupCharDatas[templateID];
					}
				}
				else {
					//Process all the tables
					for (var i = 0; i < this.tables.groups.length; i++) {
						var g = this.tables.groups[i];
						this.page[g.templateID] = page;
						this.rowCount[g.templateID] = rowCount;
						this.numFound[g.templateID] = g.numFound;
						this.pageCount[g.templateID] = Math.ceil(g.numFound / rowCount);

						var cmds = this.dataSecurityService.filterVisibleGroupsCharacteristics(this.aclService.acls, g.templateMetaData, this.tableEntityCharDataCollection.charDatas, true);
						var visibleSorted: Models.ICharacteristicMetaData[] = [];

						var sortedGroups = _.sortBy(g.templateMetaData.groups, gr => gr.sequenceNumber);
						sortedGroups.forEach((group) => {
							var groupCmds2 = cmds.filter(cmd => cmd.groupID == group.groupID);
							if (_.any(groupCmds2)) {
								visibleSorted = visibleSorted.concat(groupCmds2);
							}
						});

						this.groupCMDs[g.templateID] = visibleSorted;
						this.groupCharDatas[g.templateID] = {};
						_.forEach(this.tables.groups[i].items,
							(item) => {
								this.groupCharDatas[g.templateID][item.record.recordID] = _.groupBy(item.charData, (cd) => cd.charactersticID);

								//Pad out the collection with empty arrays for empty fields
								cmds.forEach(c => {
									if (this.groupCharDatas[g.templateID][item.record.recordID][c.characteristicID] == null) {
										this.groupCharDatas[g.templateID][item.record.recordID][c.characteristicID] = [];
									}
								})
							});

						if (templateID && g.templateID == templateID) {
							return;
						}
					}
				}

				this.tablesInitialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	GetTableCharData() {
		this.notifyService.startProgress();
		var template = Utils.IdBuilder.buildTemplateID(this.divID, this.tableCharTypeID, this.tableTemplateID);
		return this.entityService.getEmptyEntityCharData(template)
			.then((result) => {
				this.tableEntityCharDataCollection = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	CreateTable() {
		this.isTableEditing = false;
		this.isTableCreating = true;
		this.GetTableCharData()
			.then(() => {
				this.openTableModal = true;
			});
	}

	SaveTable() {
		//Save the table to the Mock
		this.notifyService.startProgress();
		if (this.isTableCreating) {
			var template = Utils.IdBuilder.buildTemplateID(this.divID, this.tableCharTypeID, this.tableTemplateID);
			this.entityService.createEntity(template, this.tableMockEntityID, this.tableEntityCharDataCollection.charDatas)
				.then((result) => {
					this.GetTables();
				})
				.finally(() => {
					this.openTableModal = false;
					this.notifyService.endProgress();
				});
		}
		else if (this.isTableEditing) {
			this.entityService.saveCharData(this.editTableEntityID, this.tableEntityCharDataCollection.charDatas)
				.then(() => {
					this.GetTables();
				})
				.finally(() => {
					this.openTableModal = false;
					this.notifyService.endProgress();
				});
		}
	}

	EditTable(table: Models.IEntity) {
		this.isTableEditing = true;
		this.isTableCreating = false;
		this.editTableEntityID = table.id;
		this.notifyService.startProgress();
		this.entityService.getEntityCharData(table.id)
			.then((results) => {
				this.tableEntityCharDataCollection = results;
				this.openTableModal = true;
				this.notifyService.endProgress();
			});
	}

	DeleteTable(table: Models.IEntity) {
		if (this.$window.confirm("Are you sure?")) {
			this.entityService.deleteEntity(table.id)
				.then((result) => {
					this.showJob(result.jobID, result.jobTitle, table.templateID, Consts.CharTypeIDs.usage);
				});
		}
	}

	TablePageSizeChanged(pageSize: number, templateID: number) {
		this.rowCount[templateID] = pageSize;
		this.GetTables(1, pageSize, templateID);
	}

	TablePageChanged(page: number, templateID: number) {
		this.page[templateID] = page;
		this.GetTables(page, this.rowCount[templateID], templateID);
	}
	//--

	private showJob(jobID: string, jobTitle: string, jobTemplateID: number, jobCharTypeID: number) {
		this.jobId = jobID;
		this.jobTitle = jobTitle;
		this.jobTemplateID = jobTemplateID;
		this.jobCharTypeID = jobCharTypeID;
		this.showJobProgressStatus = true;
	}
}